import React from "react";
import Breadcrumbs from "@/components/Breadcrumbs";
import MoleculeBg from "@/components/brand/MoleculeBg";
import { Reveal } from "@/components/motion/Reveal";

/** Deep-navy page header banner with breadcrumb + title + optional intro. */
export default function PageHeader({ overline, title, intro, breadcrumbs = [] }) {
  return (
    <section className="relative bg-[#1E2A44] overflow-hidden" data-testid="page-header">
      <MoleculeBg className="absolute -right-16 -top-10 w-[45%] h-[160%]" color="#C8A96A" opacity={0.16} />
      <div className="container-rnv pt-12 pb-16 md:pt-16 md:pb-20 relative z-10">
        {breadcrumbs.length > 0 && (
          <div className="mb-8">
            <Breadcrumbs items={breadcrumbs} onNavy />
          </div>
        )}
        <Reveal>
          {overline && <span className="overline !text-[#D8BE87]">{overline}</span>}
          <h1 className="font-serif font-light text-[#F7F4EF] text-4xl md:text-6xl mt-3 leading-[1.05] max-w-4xl">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 text-[#B9BCC4] text-lg leading-relaxed max-w-2xl">{intro}</p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
